import Loadable from "../../react-loadable";
// import RcCalendar from "../../_rc-calendar-5.6.2";
// import MonthCalendar from "../../_rc-calendar-5.6.2/src/MonthCalendar";
// import YearCalendar from "../../_rc-calendar-5.6.2/src/YearCalendar";
import createPicker from "./createPicker";
import wrapPicker from "./wrapPicker";
// import RangePicker from "./RangePicker";
// import DateGroup from "./DateGroup";
// import Calendar from "./Calendar";
const RcCalendar = Loadable({
  loader: () => import("../../_rc-calendar-5.6.2"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const MonthCalendar = Loadable({
  loader: () => import("../../_rc-calendar-5.6.2/src/MonthCalendar"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const YearCalendar = Loadable({
  loader: () => import("../../_rc-calendar-5.6.2/src/YearCalendar"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const RangePicker = Loadable({
  loader: () => import("./RangePicker"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const DateGroup = Loadable({
  loader: () => import("./DateGroup"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

const DatePicker = wrapPicker(createPicker(RcCalendar));
const MonthPicker = wrapPicker(
  createPicker(MonthCalendar, "yyyy-MM"),
  "yyyy-MM"
);
const YearPicker = wrapPicker(createPicker(YearCalendar), "yyyy");

DatePicker.Calendar = Loadable({
  loader: () => import("./Calendar"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
DatePicker.RangePicker = wrapPicker(RangePicker, "yyyy-MM-dd");
DatePicker.DateGroup = wrapPicker(DateGroup, "yyyy-MM-dd");
DatePicker.MonthPicker = MonthPicker;
DatePicker.YearPicker = YearPicker;

export default DatePicker;



// WEBPACK FOOTER //
// ./_antd1.11.2/date-picker/index.jsx